<template>
    <div class="page choose-office">

        <div class="search">
            <van-search v-model="value" clearable @focus="is_search = true" @clear="is_search = false" @input="onSearch" placeholder="搜索添加更多科室" />
        </div>

        <div class="choose-office-title">
            科室列表
        </div>

        <div class="choose-office-content">
            <van-radio-group v-model="radio" v-if="value != ''" checked-color="#d3172e">
                <van-cell-group :border="false">
                    <van-cell clickable @click="changeSearch(index)" v-for="(item,index) in search_office" :key="index">
                        <template slot="title">
                            <span class="choose-office-content-title" v-html="item.light_name"></span>
                        </template>
                    </van-cell>
                    <van-cell clickable @click="addOffice">
                        <template slot="title">
                            <span class="choose-office-content-title">
                                <img src="/static/img/login/icon_login_add.svg" alt=""> 添加科室“{{value}}”
                            </span>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <van-radio-group v-model="radio" v-if="value == ''" checked-color="#d3172e">
                <van-cell-group :border="false">
                    <van-cell clickable @click="change(index)" v-for="(item,index) in office" :key="index">
                        <template slot="icon">
                            <van-radio :name="index" />
                        </template>
                        <template slot="title">
                            <span class="choose-office-content-title" v-html="item.name"></span>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>

        <div class="choose-office-confirm">
            <van-cell class="choose-office-confirm-cell">
                <template slot="title">
                    <div class="choose-office-confirm-left">已选：</div>
                    <div class="choose-office-confirm-content">{{formData.office}}</div>
                    <van-button class="choose-office-confirm-btn" type="danger" @click="chooseOffice()" color="#0FB7AD" round size="small">确定</van-button>
                </template>
            </van-cell>
        </div>

    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value:"",
                radio:"",
                office:[],
                search_office:[],
                formData : {},
                is_search:false,
            }
        },
        methods: {
            onSubmit(){},
            onSearch(){
                Interface.getData('get',Interface.user.office_search,{hospital_id:this.formData.hospital_id,name:this.value,pageSize:999}).then((res)=>{
                    this.search_office = res.data
                })
            },
            addOffice(){
                Interface.getData('post',Interface.user.office,{hospital_id:this.formData.hospital_id,name:this.value,city_id:this.formData.city_id}).then((res)=>{
                    if(res.code == 0){
                        this.$toast.success("添加成功")
                        this.onSearch()
                    }
                })
            },
            fetch(scene) {
                if (scene === 'office') {
                    Interface.getData('get',Interface.user.office,{hospital_id:this.formData.hospital_id,pageSize:999}).then((res)=>{
                        if (res.code == 0){
                            this.office = res.data
                            this.init();
                        }
                    })
                }
            },
            chooseOffice(){
                let formData = JSON.parse(sessionStorage.getItem('add-info'))
                if(this.is_search){
                    formData.office    = this.search_office[this.radio].name
                    formData.office_id = this.search_office[this.radio].id
                }else {
                    formData.office = this.office[this.radio].name
                    formData.office_id = this.office[this.radio].id
                }
                sessionStorage.setItem('add-info',JSON.stringify(formData))
                this.$router.push({
                    name : "add-info",
                })
            },
            change(index){
                this.radio = index
                this.formData.office = this.office[this.radio].name
            },
            changeSearch(index){
                this.radio = index
                this.formData.office = this.search_office[this.radio].name
            },
            init(){
                if(this.office.length > 0){
                    this.office.forEach( (val,index)=> {
                        if (val.id == this.formData.office_id){
                            this.radio = index
                        }
                    })
                }
            }
        },
        created() {
            this.formData = JSON.parse(sessionStorage.getItem('add-info'))
            Interface.getShareInfo(this,"","","")
            this.fetch('office')
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/choose-office/index.vue